import PapelSegurancaLoteItensService from "@/services/PapelSeguranca/PapelSegurancaLoteItensService"
import custas from "../constants/custas"

export async function ConsomePapel (papelCusta, item, index) {
  const isPapelArray = Array.isArray(papelCusta.papelSeguranca)
  const papelSeguranca = isPapelArray ? papelCusta.papelSeguranca[index] : papelCusta.papelSeguranca
  const tipoPapel = papelCusta.papelSeguranca[index].papelSegurancaLote.tipo_papel

  try {
    loader({ text: 'Consumindo papel de segurança...', active: true })
    const papelConsumido = await PapelSegurancaLoteItensService.consumeSelo(papelSeguranca, item, tipoPapel)
    return papelConsumido
  } catch (error) {
    const message = getErrors(error)
    await displayMessage('error', 'Erro!', message.message)
  } finally {
    loader({ text: '', active: false })
  }
}

export function verificaImpressos (cod) {
  const atosImpresso = custas.impressos
  return atosImpresso.includes(cod)
}
